import styled from "styled-components";
import Profile from "../../common/Profile";
import DescrEditor from "./DescrEditor";
import { template } from "../data";

const CommentWrapper = styled.div`
  width: 100%;
  height: ${(props) => props.height};
  margin-top: 32px;
  display: flex;
  > div:first-child {
    margin-right: 16px;
  }
`;

const Comment = (props) => {
  const { cmtRef, mode, userInfo } = props;

  return (
    <CommentWrapper height={mode === "create" ? "800px" : "400px"}>
      <Profile employeeNo={userInfo.employeeNo} />
      <DescrEditor cmtRef={cmtRef} defaultValue={template[mode]} />
    </CommentWrapper>
  );
};

export default Comment;
